import { frontendURL } from '../../../../helper/URLHelper';

const newReports = accountId => ({
  parentNav: 'newReports',
  routes: ['new_conversation_reports', 'new_create_mode_reports'],
  menuItems: [
    {
      icon: 'chat',
      label: 'REPORTS_CONVERSATION',
      hasSubMenu: false,
      toState: frontendURL(`accounts/${accountId}/new-reports/conversation`),
      toStateName: 'new_conversation_reports',
    },
    {
      icon: 'add',
      label: 'REPORT_BUILDER',
      hasSubMenu: false,
      toState: frontendURL(`accounts/${accountId}/new-reports/create-mode`),
      toStateName: 'new_create_mode_reports',
    },
  ],
});

export default newReports;
